import React, { useState } from 'react';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Paper } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  }
}));

const BusinessDashboard = props => {
  const classes = useStyles();
  const [page, setPage] = useState(5);

  const header = [
    { field: 'Code', headerName: 'Code', width: 165 },
    { field: 'Name', headerName: 'Name', width: 220 },
    {
      field: 'lastRunTime',
      headerName: 'Last Run',
      width: 150,
      valueFormatter: (params) => {
        return params.value?.substring(0, 10);
      },
    },
    { field: 'currStatus', headerName: 'Current Status', width: 180 },
    {
      field: 'nextRun',
      headerName: 'Next Run',
      width: 150,
      valueFormatter: (params) => {
        return params.value?.substring(0, 10);
      },
    },
  ];

  const jobs = [
    { 'id': 0, 'Code': 'SDMS-MPBL_GEN', 'Name': 'Map Block Lot Generator', 'lastRunTime': '2/1/2020  11:00:00 AM', 'currStatus': 'Running', 'nextRun': '2/2/2020  11:00:00 AM' },
    { 'id': 1, 'Code': 'SDMS-ASBL_GEN', 'Name': 'Assessor Block Lot Generator', 'lastRunTime': '2/11/2020  11:00:00 AM', 'currStatus': '', 'nextRun': '2/12/2020  11:00:00 AM' }
  ];

  return (
    <Container maxWidth="md">
      <Paper className={classes.paper}>
        <DataGrid
          columns={header}
          rows={jobs}
          pageSize={page}
          onPageSizeChange={(pageSize, details) => { setPage(pageSize); }}
          autoHeight
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Container>
  )
};

export default BusinessDashboard;